import styled from "styled-components";
import cssObjectForPrimaryState from "../../../actions/Button/styling/functions/cssObjectForPrimaryState";
import merge from "lodash.merge";
import Typography from "../../../typography/Typography/Typography";
import { StyledMainButtonProps } from "./ProxyBidButton.types";

export const StyledButtonLabel = styled(Typography)`
	position: absolute;
	top: 50%;
	left: 50%;
	transition: top 0.2s ease-in-out;
	transform: translate(-50%, -50%);
`;

export const StyledMainButton = styled.button<StyledMainButtonProps>`
	position: relative;
	margin: 0;
	padding: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	min-width: ${({ buttonRole }) => (buttonRole === "apply" ? "68px" : "87px")};
	&:not(:disabled) {
		cursor: pointer;
		${({ buttonRole, theme }) => {
			const bgColor = theme.palette.hexFor("semantic_error_600");

			return buttonRole !== "apply"
				? {
						backgroundColor: bgColor,
						"&:hover": {
							backgroundColor: bgColor,
						},
				  }
				: {};
		}}
	}
	height: 100%;
	border: none;
	border-radius: 0px 24px 24px 0px;
	transition: all 300ms ease-in-out;
	transform-origin: 100% 50%;
	overflow: hidden;

	&:disabled {
		> div > .Icon > svg {
			fill: ${({ theme }) => theme.palette.hexFor("white")};
		}
	}
	${({ viewport, theme }) => {
		const isMobileDevice = ["xs", "sm"].includes(viewport?.currentSize);

		return {
			...(isMobileDevice && {
				borderRadius: theme.radii.lg,
				marginTop: theme.space.xs,
			}),
		};
	}}

	${({ theme }) => {
		const FG_LIGHT_1 = theme.palette.hexFor("fg_light_1");
		const COLOR_CTA_DEFAULT = theme.palette.hexForRole("cta_default");
		const COLOR_CTA_HOVER = theme.palette.hexForRole("cta_hover");
		const COLOR_CTA_ACTIVE = theme.palette.hexForRole("cta_active");
		const COLOR_CTA_DISABLED = theme.palette.hexForRole("cta_disabled");
		const COLOR_NEUTRAL_400 = theme.palette.hexFor("neutral_400");

		return merge(
			cssObjectForPrimaryState(COLOR_CTA_DEFAULT, FG_LIGHT_1, FG_LIGHT_1),
			{
				"&:hover": cssObjectForPrimaryState(
					COLOR_CTA_HOVER,
					FG_LIGHT_1,
					FG_LIGHT_1
				),
				"&:active": cssObjectForPrimaryState(
					COLOR_CTA_ACTIVE,
					FG_LIGHT_1,
					FG_LIGHT_1
				),
				"&:disabled": cssObjectForPrimaryState(
					COLOR_CTA_DISABLED,
					COLOR_NEUTRAL_400,
					COLOR_NEUTRAL_400
				),
			}
		);
	}}
`;
